import React, { useMemo, useCallback } from 'react';
import { SingleSelectButtonGroup } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const AllInseamsButtonGroup = () => {
  const [state, dispatch] = useProductDetailsPageContext();

  const currentInseam = useMemo(() => {
    return state.onRecommendedSizesTab
      ? state.recommendedSkuInseamLabel
      : state.selectedInseamLabel;
  }, [
    state.onRecommendedSizesTab,
    state.recommendedSkuInseamLabel,
    state.selectedInseamLabel,
  ]);

  const handleInseamSizeFilterClick = useCallback(
    inseamLabel => {
      dispatch({ type: 'INSEAM_SELECTED', payload: { inseamLabel } });
    },
    [dispatch],
  );

  // filter out skus with no inseams. They return "null" as the inseam value.
  const inseamOptions = useMemo(() => {
    return state.inseamOptions.filter(inseam => inseam);
  }, [state.inseamOptions]);

  // return early if no inseams
  if (inseamOptions.length === 0) {
    return null;
  }

  const singleSelectButtonGroupOptions = [...inseamOptions]
    .sort((a, b) => a.label - b.label)
    .map(inseam => {
      return {
        value: inseam.label,
        label: `${inseam.label}"`,
        status: inseam.availability ? 'enabled' : 'unavailable',
        'aria-label': `Inseam ${inseam.label}"${
          inseam.availability ? '' : ' - out of stock'
        }`,
      };
    });

  return (
    <SingleSelectButtonGroup
      mb={1}
      mt={0.5}
      options={singleSelectButtonGroupOptions}
      value={currentInseam}
      name="inseams"
      onChange={selectedInseamValue =>
        handleInseamSizeFilterClick(selectedInseamValue)
      }
    />
  );
};

export default React.memo(AllInseamsButtonGroup);
